import React, { createContext, useContext, useState, useEffect } from "react";

const RATES = { chf: 1.0, eur: 1.05 };
const LOCALES = { chf: "de-CH", eur: "de-DE" };

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(() => localStorage.getItem("currency") || "chf");
  useEffect(() => { localStorage.setItem("currency", currency); }, [currency]);

  const rate = RATES[currency] || 1;
  const format = (chfAmount) =>
    new Intl.NumberFormat(LOCALES[currency] || "de-CH", {
      style: "currency", currency: currency.toUpperCase(),
    }).format((chfAmount || 0) * rate);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, rate, format }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
